<template>
  <v-row class="ma-0">
    <v-col cols="12" class="wsp-wallpaper pb-5">
      <v-card class="mx-4 mt-4 mb-0 py-2">
        <v-col v-if="headerType === 'image'" cols="12" class="pb-0">
          <img :src="headerMediaUrl" width="100%" />
        </v-col>
        <v-col v-if="headerType === 'document'" cols="12" class="pb-2">
          <div class="pa-2 text-caption text--lighten-2" :style="{ 'background-color': '#eee' }">
            <v-icon size="x-small" class="mr-2">fa fa-file</v-icon>
            {{ headerMediaName }}{{ headerMediaExtension ? `.${headerMediaExtension}` : "" }}
          </div>
        </v-col>
        <v-col v-if="headerType === 'video'" cols="12" class="pb-2">
          <div class="pa-2 text-caption text--lighten-2" :style="{ 'background-color': '#eee' }">
            <v-icon size="x-small" class="mr-2">fa fa-video</v-icon>
            {{ headerMediaName }}
          </div>
        </v-col>
        <v-col v-if="header" cols="12" class="py-1 font-weight-bold">
          <span>{{ header }}</span>
        </v-col>
        <v-col cols="12" class="py-1">
          <span v-if="body" v-html="formattedBody"></span>
        </v-col>
        <v-col cols="12" class="py-1 text-caption text--secondary">
          <span v-if="footer">{{ footer }}</span>
        </v-col>
        <v-col cols="12" class="py-0 text-caption text--secondary text-right">
          <span>07:42</span>
        </v-col>
      </v-card>
      <template v-for="(button, i) in buttons">
        <v-card v-if="button.title" :key="i" class="mx-4 mt-1 py-1 text-center info--text">
          {{ button.title }}
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MessagePreview",
  props: {
    headerMedia: {
      type: Object,
      default: () => ({}),
    },
    headerText: {
      type: String,
      default: "Encabezado texto",
    },
    bodyText: {
      type: String,
      default: "Texto",
    },
    footerText: {
      type: String,
      default: "Pie de página",
    },
    allOptions: {
      type: Array,
      default: () => [],
    },
    messageTemplateSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      headerType: "text",
      headerMediaUrl: null,
      headerMediaName: null,
      headerMediaExtension: "",
      header: "",
      body: "",
      footer: "",
      buttons: [],
    };
  },
  computed: {
    formattedBody() {
      return this.body.replace(/\n/g, "<br>");
    },
  },
  watch: {
    headerMedia(value) {
      this.headerType = value?.type || "";
      this.headerMediaName = value?.name || "";
      this.headerMediaUrl = value?.url || "";
      this.headerMediaExtension = value?.extension || "";
    },
    headerText(value) {
      this.header = value || "";
    },
    bodyText(value) {
      this.body = value || "";
    },
    footerText(value) {
      this.footer = value || "";
    },
    messageTemplateSelected(value) {
      if (value) this.loadMessageTemplate(value);
    },
    allOptions(value) {
      this.buttons = value;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!Object.keys(this.messageTemplateSelected)) return;

      this.loadMessageTemplate(this.messageTemplateSelected);
    },
    loadMessageTemplate(messageTemplate) {
      const components = messageTemplate.components;
      if (!components) return;

      const header = components.find((c) => c.type === "HEADER");
      if (header) {
        switch (header.format) {
          case "TEXT":
            this.headerType = "text";
            this.header = header?.text || "";
            break;
          case "IMAGE":
            this.headerType = "image";
            this.headerMediaUrl = messageTemplate?.custom_media?.file_url || "";
            break;
          case "DOCUMENT":
            this.headerType = "document";
            this.headerMediaName = messageTemplate?.custom_media?.file_name;
            break;
        }
      }

      const body = components.find((c) => c.type === "BODY");
      this.body = body?.text || "";

      const footer = components.find((c) => c.type === "FOOTER");
      this.footer = footer?.text || "";

      const buttons = components.find((c) => c.type === "BUTTONS");
      this.buttons = buttons?.buttons.map((b) => ({ ...b, title: b.title || b.text })) || [];
    },
  },
};
</script>

<style scoped>
.wsp-wallpaper {
  background-color: #e5ddd5;
  position: relative;
}

.wsp-wallpaper::before {
  background-image: url("https://storage.googleapis.com/wegrou-assets-dev/assets/wsp-wallpaper.png");
  opacity: 0.08;
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
